import React from 'react';
import { Helmet } from 'react-helmet';

const Impressum = () => {
    return (
        <>
          <Helmet>
            <meta name="robots" content="noindex, nofollow" />
          </Helmet>
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-3xl mx-auto bg-white p-8 rounded-lg shadow">
        <h1 className="text-3xl font-bold mb-6">Impressum</h1>
        
        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Angaben gemäß § 5 TMG</h2>
          <p className="mb-2">[Christian Lamping]</p>
          <p className="mb-2">[Muehlenstrasse 19]</p>
          <p className="mb-4">[49429 Visbek]</p>
        </section>
        
        {/* <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Kontakt</h2>
          <p className="mb-2">Telefon: [Ihre Telefonnummer]</p>
          <p className="mb-2">E-Mail: [Ihre E-Mail-Adresse]</p>
        </section> */}
        
        {/* <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Umsatzsteuer-ID</h2>
          <p className="mb-2">Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:</p>
          <p className="mb-4">[Ihre USt-IdNr.]</p>
        </section> */}
        
        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
          <p className="mb-2">[Christian Lamping]</p>
          <p className="mb-2">[Muehlenstrasse 19]</p>
          <p className="mb-4">[49429 Visbek]</p>
        </section>
        
        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Streitschlichtung</h2>
          <p className="mb-4">Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a href="https://ec.europa.eu/consumers/odr" className="text-blue-600 hover:underline">https://ec.europa.eu/consumers/odr</a></p>
          <p className="mb-4">Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>
          <p className="mb-4">Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
        </section>
        
        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Haftung für Inhalte</h2>
          <p className="mb-4">Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.</p>
        </section>
      </div>
    </div>
    </>
  );
};

export default Impressum;